import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-documents-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-documents-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { ApplicationViewService } from "../../application-view.service";
import { SaLongDatePipe } from "../../../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { AppConfig } from "../../../../app.config";
import { ApiAttachmentConstants } from "../../../../shared/constants/api-constants/api-attachment.constants";
import { AddDocumentDialogConstants } from "./add-document-dialog.constants";
import { FileUtils } from "src/app/shared/utils/file-utils";
import { FileService } from "../../../../shared/services/file/file.service";
let AddDocumentsDialogComponent = class AddDocumentsDialogComponent {
    activeModal;
    saLongDatePipe;
    userInformationService;
    applicationViewService;
    requestStatusService;
    fileUploadService;
    appControllerService;
    documentTypes = [];
    dialogTitle;
    configUploadSettings;
    currentApplication;
    selectedDocumentType;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    addDocumentForm;
    documentTypeLabel = AddDocumentDialogConstants.DOCUMENT_TYPE_LABEL;
    descriptionLabel = AddDocumentDialogConstants.DESCRIPTION_LABEL;
    fileLabel = AddDocumentDialogConstants.FILE_LABEL;
    selectFileLabel = AddDocumentDialogConstants.SELECT_FILE_LABEL;
    cancelBtnPlaceholder = AddDocumentDialogConstants.CANCEL_BTN_PLACEHOLDER;
    documentTypeFormControlName = AddDocumentDialogConstants.DOCUMENT_TYPE_FORM_CONTROL;
    descriptionFormControlName = AddDocumentDialogConstants.DESCRIPTION_FORM_CONTROL;
    fileNameFormControlName = AddDocumentDialogConstants.FILE_NAME_FORM_CONTROL;
    saveBtnPlaceholder = AddDocumentDialogConstants.SAVE_BTN_LABEL;
    uploadedFiles = [];
    documentTypeErrMsg = AddDocumentDialogConstants.DOCUMENT_TYPE_ERR_MSG;
    descriptionErrMsg = AddDocumentDialogConstants.DESCRIPTION_ERR_MSG;
    noFileUploadedErrMsg = AddDocumentDialogConstants.NO_FILE_UPLOADED_ERR_MSG;
    selectedFile;
    maxFileSize;
    allowedFiles = [];
    filteredAllowedFileTypes = [];
    documentUploadedBy;
    uploadDocumentObservableSubscription;
    authenticatedUserSubscription;
    constructor(activeModal, saLongDatePipe, userInformationService, applicationViewService, requestStatusService, fileUploadService, appControllerService) {
        this.activeModal = activeModal;
        this.saLongDatePipe = saLongDatePipe;
        this.userInformationService = userInformationService;
        this.applicationViewService = applicationViewService;
        this.requestStatusService = requestStatusService;
        this.fileUploadService = fileUploadService;
        this.appControllerService = appControllerService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
        this.maxFileSize = this.configUploadSettings.maximumSize;
        this.allowedFiles = this.configUploadSettings.agsSupportedAttachmentFileTypes.split(",");
        this.filteredAllowedFileTypes = FileUtils.mapAllowedFilesToMimeTypes(this.allowedFiles);
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.subscribe((userInfo) => {
            this.documentUploadedBy = `${userInfo.lastName} ${userInfo.firstName}`;
        });
        this.addDocumentForm.get(this.documentTypeFormControlName).setValue(this.selectedDocumentType);
    }
    uploadFile(files) {
        const key = "Uploading and validating files...";
        try {
            this.requestStatusService.showBusySpinner(key);
            const fileToUpload = files instanceof Event
                ? (files.target?.files?.[0] ?? null)
                : files?.[0] ?? null;
            if (!fileToUpload) {
                return;
            }
            const fileExtension = fileToUpload.name
                .substring(fileToUpload.name.lastIndexOf(".") + 1)
                .toUpperCase();
            if (!this.isFileAllowed(fileExtension)) {
                const allowedExtensions = this.allowedFiles.join(",");
                this.appControllerService.showMessage(`The file you have selected is not supported: ${fileExtension}.\n
        Please choose a different file. Only files with the following extensions are supported: ${allowedExtensions}.`, AlertType.Warning);
                return;
            }
            if (this.maxFileSize !== undefined && this.maxFileSize !== null && fileToUpload.size > this.maxFileSize) {
                this.appControllerService.showMessage(`Attached file size is ${this.bytesToSize(fileToUpload.size)} and allowed file size is ${this.bytesToSize(this.maxFileSize)}`, AlertType.Warning);
                return;
            }
            this.selectedFile = fileToUpload;
            this.uploadedFiles[0] = fileToUpload.name;
        }
        catch (error) {
            this.appControllerService.showMessage("An unexpected error occurred while uploading the file. Please try again.", AlertType.Error);
        }
        finally {
            this.requestStatusService.removeBusySpinner(key);
        }
    }
    isFileAllowed(fileExtension) {
        let isFileAllowed = false;
        this.allowedFiles.forEach(element => {
            if (element.toUpperCase() === fileExtension) {
                isFileAllowed = true;
            }
        });
        return isFileAllowed;
    }
    bytesToSize(bytes) {
        const sizes = ["Bytes", "KB", "MB", "GB"];
        if (bytes === 0)
            return "0 Byte";
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
        if (i === 0)
            return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        if (this.addDocumentForm.valid && this.addDocumentForm.touched && this.uploadedFiles.length > 0) {
            try {
                this.requestStatusService.clearBusyRequestCounter();
                this.requestStatusService.showBusySpinner("save");
                this.uploadAttachment();
            }
            catch (e) {
                this.appControllerService.showMessage(SharedConstants.ADD_DOCUMENT_FAIL, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("save");
            }
        }
        else {
            Object.keys(this.addDocumentForm.controls).forEach(key => {
                if (this.addDocumentForm.get(key).invalid) {
                    this.addDocumentForm.get(key).markAsTouched();
                }
            });
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    deleteAttachment(i, $event) {
        this.uploadedFiles.splice(i, 1);
        if (this.uploadedFiles.length === 0) {
            this.addDocumentForm.get(this.fileNameFormControlName).reset();
            this.selectedFile = null;
        }
        $event.stopPropagation();
    }
    initForm() {
        this.addDocumentForm = new FormGroup({
            documentType: new FormControl(null, Validators.required),
            description: new FormControl(null, Validators.required),
            fileName: new FormControl(null)
        });
    }
    uploadAttachment() {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        const formData = new FormData();
        formData.append("appId", this.currentApplication.appId.toString());
        formData.append("jobId", this.currentApplication.jobId.toString());
        formData.append("moduleId", this.appControllerService.selectedModuleID);
        formData.append("fileName", this.selectedFile.name);
        formData.append("description", this.addDocumentForm.get(this.descriptionFormControlName).value);
        formData.append("attachmentType", this.addDocumentForm.get(this.documentTypeFormControlName).value);
        formData.append("componentType", "Upload AFLA portal required documents");
        formData.append("aflaPortalObjectId", "0");
        formData.append("uploadedBy", this.documentUploadedBy);
        formData.append("file", this.selectedFile);
        formData.append("source", "Supplementary");
        const url = `${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_UPLOAD_ATTACHMENT_FROM_PORTAL}`;
        this.fileUploadService.uploadFile(url, formData, "portal", "Supplementary", true, (result) => {
            if (result !== null) {
                this.appControllerService.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                const newDocument = {
                    id: result.id,
                    type: this.addDocumentForm.get(this.documentTypeFormControlName).value,
                    name: this.addDocumentForm.get(this.descriptionFormControlName).value,
                    fileName: this.selectedFile.name,
                    dateUploaded: this.saLongDatePipe.transform(new Date().getTime().toString())
                };
                this.activeModal.close(newDocument);
            }
            this.requestStatusService.removeBusySpinner("save");
            this.requestStatusService.removeBusySpinner("upload");
        });
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: SaLongDatePipe },
        { type: UserInformationService },
        { type: ApplicationViewService },
        { type: RequestStatusService },
        { type: FileService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        documentTypes: [{ type: Input }],
        dialogTitle: [{ type: Input }],
        configUploadSettings: [{ type: Input }],
        currentApplication: [{ type: Input }],
        selectedDocumentType: [{ type: Input }]
    };
};
AddDocumentsDialogComponent = __decorate([
    Component({
        selector: "app-add-documents-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { "add-documents-dialog": "view-application" },
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], AddDocumentsDialogComponent);
export { AddDocumentsDialogComponent };
